import { Grid } from "@mui/material";
import { useEffect } from "react";
import { Outlet } from "react-router";
import biApi from "../../../../../api/biApi";
import ReportsManager from "../../../reporting/report-lists/contexts/reports-manager/ReportsManager";
import { ReportsContextProvider } from "../../../reporting/report-lists/contexts/reports/ReportsContextProvider";
import { GroupsContextProvider } from "../../../reporting/report-lists/groups/contexts/GroupsContextProvider.tsx";
import useGroups from "../../../reporting/report-lists/groups/hooks/useGroups.ts";
import useReports from "../../../reporting/report-lists/hooks/useReports";
import {
  getEditUiReportUrl,
  getViewUiReportUrl,
} from "../../../reporting/report-lists/reports/utilities/editReportUrl";
import { BiApiClientProvider } from "../../../reporting/sv/contexts/BiApiClientProvider.tsx";
import type { BiApiClientBase } from "../../../reporting/sv/contexts/BiApiClientProviderContext.ts";

const UiOrganizationReportsPage = () => {
  const { reports, ui, actions } = useReports(biApi.uiOrganizationReports.getOrganizationReports, "Ui");
  const {
    groups,
    actions: groupActions,
    ui: groupsUi,
  } = useGroups({
    ...biApi.uiReportGroup,
    applyGroupSharing: actions.applyGroupSharing,
    getOrganizationReportGroups: biApi.uiOrganizationReports.getOrganizationReportGroups,
  });

  const { loadOrganizationGroups } = groupActions;
  useEffect(() => {
    loadOrganizationGroups();
  }, [loadOrganizationGroups]);

  return (
    <Grid container sx={{ flex: 1, width: "100%" }}>
      <BiApiClientProvider<BiApiClientBase>
        api={{
          validateName: biApi.uiReports.validateReportName,
          getReportSharing: biApi.uiReports.getReportSharing,
          updateReportSharing: biApi.uiReports.updateReportSharing,
          getEditReportUrl: getEditUiReportUrl,
          getViewReportUrl: getViewUiReportUrl,
        }}
      >
        <ReportsContextProvider reports={reports} ui={{ loaded: ui.loaded, error: ui.error }} actions={actions}>
          <GroupsContextProvider
            groups={groups}
            ui={groupsUi}
            actions={{ ...groupActions, reloadReports: actions.reloadReports }}
          >
            <ReportsManager
              onCopied={actions.reloadReports}
              onDeleted={actions.reloadReports}
              reports={reports}
              reportUsage={"Ui"}
              openInNewTab={true}
            >
              <Outlet />
            </ReportsManager>
          </GroupsContextProvider>
        </ReportsContextProvider>
      </BiApiClientProvider>
    </Grid>
  );
};

export default UiOrganizationReportsPage;
